import { Icon } from '@eb/eds-icon';
import { ArrowLeft } from '@eb/eds-iconography';
import { gettext } from '@eventbrite/i18n';
import React, { useContext } from 'react';
import { AnalyticsContext, ApplicationContext } from '../context';
import { AnalyticsAction, AnalyticsCategory, trackEvent } from '../_shared';

export const OrganizerUiBanner: React.FC = () => {
    const context = useContext(ApplicationContext);
    const { collectionId, organizerId } = useContext(AnalyticsContext);
    const justPublished = context?.request.params.just_published || false;
    const bannerText = justPublished
        ? gettext(
              'Congratulations! You’ve published your collection.',
          ).toString() +
          ' ' +
          '🎉'
        : gettext('Here’s how your collection looks.').toString() + ' ' + '👀';

    return (
        <div
            className="cc-organizer-banner"
            role="banner"
            aria-labelledby="banner-text"
        >
            <div className="cc-organizer-banner__wrapper">
                {collectionId && (
                    <a
                        href={`/manage/collections/${collectionId}/publish`}
                        className="cc-organizer-banner__link eds-text-bm eds-text-weight--heavy eds-text-color--control eds-show-up-md"
                        onClick={() => {
                            trackEvent({
                                action: AnalyticsAction.EditCollection,
                                label: 'organizer-banner',
                                category: AnalyticsCategory.Listing,
                                dimensions: {
                                    collectionId,
                                    organizerId,
                                },
                            });
                        }}
                    >
                        <Icon
                            arial-label="hidden"
                            color="ui-blue--hover"
                            size="xsmall"
                            type={<ArrowLeft />}
                        />
                        <span className="eds-l-pad-left-2">
                            {gettext('Edit this collection')}
                        </span>
                    </a>
                )}
                <p id="banner-text" className="eds-text-hm eds-l-pad-vert-5">
                    {bannerText}
                </p>
            </div>
        </div>
    );
};
